import { armorNuggetsColumn } from "../resource/armor-nuggets-column";
import { NeededColumn } from "./needed-column";

export const armorNuggetNeededColumn = new NeededColumn(
  "eccebd46-741e-4c13-beb9-de7030d64448",
  armorNuggetsColumn,
  "Blue Nug Needed"
)
